export function mapStringToOptions(lista: string[]) {
    return lista.map(item => ({ key: item, value: item, text: item }));
}



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/utils/mapStringToOptions.ts